import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = { selector: String }

  show() {
    $(this.selectorValue).tab("show")
  }
}
